import React from 'react';
import { useTranslation } from 'react-i18next';

import ProjectsAndIncentivesPageLayout from '../../components/ProjectsAndIncentivesPageLayout';
import SEO from '../../components/SEO';
import PORLisboaLogoPng from '../../assets/images/logos/logo_porlisboa.png';
import QRENLogoPng from '../../assets/images/logos/qren-logo.png';
import FEDERLogoPng from '../../assets/images/logos/FEDER-logo.png';

import * as styles from './incentives.module.scss';

const incentives = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <ProjectsAndIncentivesPageLayout currentSlug="incentives">
      <SEO
        title={t('projects_and_incentives.incentives_page.title', 'Incentives')}
        urlPath={'/projects-and-incentives/incentives'}
      />
      <h1>Incentives</h1>
      <div className={styles.logos}>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={PORLisboaLogoPng} alt="POR Lisboa Logo" />
        </div>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={QRENLogoPng} alt="QREN Logo" />
        </div>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src={FEDERLogoPng} alt="FEDER Logo" />
        </div>
      </div>
      <p>
        <strong>Project designation:</strong> Innovation in Crop Protection products in the
        Brazilian market
      </p>
      <p>
        <strong>Incentive:</strong> Incentive System for Innovation under the Regional Operational
        Programme of Lisbon
      </p>
      <p>
        <strong>Scope:</strong> Manufacturing of new crop protection products non-existent on
        international markets, particularly in Brazil. Promoting innovation in business and
        orientation towards foreign markets
      </p>
      <p>
        <strong>Total investment approved:</strong> €2.155.179,19
      </p>
      <p>
        <strong>Approved incentive value:</strong> €500.000,00
      </p>
      <hr></hr>
      <p>
        <strong>Project designation:</strong> Innovation in the national supply of plant protection
        products
      </p>
      <p>
        <strong>Incentive:</strong> Incentive System for Innovation under the Regional Operational
        Programme of Lisbon
      </p>
      <p>
        <strong>Scope:</strong> Manufacturing of 5 new plant protection products in the fields
        of herbicides and fungicides, aimed primarily for exportation (mainly to Spain, France and
        Italy). The products are remarkably innovative in the sector where the Company plays at
        both national and international level
      </p>
      <p>
        <strong>Total investment approved:</strong> €2.891.034,98
      </p>
      <p>
        <strong>Approved incentive value:</strong> €500.000,00
      </p>
    </ProjectsAndIncentivesPageLayout>
  );
};

export default incentives;
